import React from "react";
import { StarFull } from "./StarFull";
import { StarEmpty } from "./StarEmpty";

export const Stars = ({ reviewScore, classes }) => {

  const starFullCount = reviewScore && Math.round(+reviewScore / 2);
  const starEmptyCount = starFullCount && 5 - starFullCount;
  const starFullArr = [...Array(starFullCount).keys()];
  const starEmptyArr = [...Array(starEmptyCount).keys()];

  return (
    <div className="flex items-center">
      {starFullArr?.map((star) => (
        <StarFull key={star} classes={classes} />
      ))}
      {starEmptyArr?.map((star) => (
        <StarEmpty key={star} classes={classes} />
      ))}
    </div>
  );
};
